import { lazyWithRetry } from './customReactLazy';
import { RoutePaths } from './routePaths';
const Home = lazyWithRetry(() => import('./pages/Home'));
const Page404 = lazyWithRetry(() => import('./pages/404'));
const Info = lazyWithRetry(() => import('./pages/Info'));
const Catalogue = lazyWithRetry(() => import('./pages/Catalogue'));
const DatasetPage = lazyWithRetry(() => import('./pages/DatasetPage'));
const Collection = lazyWithRetry(() => import('./pages/Collection'));
const Tutorials = lazyWithRetry(() => import('./pages/Tutorials'));
const Search = lazyWithRetry(() => import('./pages/Search'));
const MyProfile = lazyWithRetry(() => import('./pages/Profile/MyProfile'));
const Reports = lazyWithRetry(() => import('./pages/Reports'));
const Merge = lazyWithRetry(() => import('./pages/DatasetPage/MergeDatasets'));
const DataProcessingReport = lazyWithRetry(() => import('./pages/DatasetPage/DatasetProcessingReport'));
const GetApi = lazyWithRetry(() => import('./pages/GetApi'));
const StaticWeights = lazyWithRetry(() => import('./shared/Dataset/Weights'));
const Help = lazyWithRetry(() => import('./pages/Help'));
const UnSubScribe = lazyWithRetry(() => import('./pages/UnSubScribe'));
const UseCaseDashboard = lazyWithRetry(() => import('./pages/UseCaseDashboard'));
const ResearchPapers = lazyWithRetry(() => import('./pages/ResearchPapers'));
const NewsLetter = lazyWithRetry(() => import('./pages/NewsLetter'));
const Publications = lazyWithRetry(() => import('./pages/Publications'));

export const publicRoutes = () => {
  return [
    {
      path: RoutePaths.PAGE_404,
      component: Page404,
      exact: true,
    },
    {
      path: RoutePaths.INFO,
      component: Info,
      exact: true,
    },
    {
      path: RoutePaths.CATALOGUE,
      component: Catalogue,
      exact: true,
    },
    {
      path: `${RoutePaths.TUTORIALS}`,
      component: Tutorials,
      exact: true,
    },
    {
      path: `${RoutePaths.SEARCH}`,
      component: Search,
      exact: true,
    },
    {
      path: `${RoutePaths.REPORTS}/:id`,
      component: Reports,
      exact: true,
    },
    {
      path: `${RoutePaths.WEIGHTED_AVERAGE}`,
      component: StaticWeights,
      exact: true,
    },
    {
      path: `${RoutePaths.HELP}`,
      component: Help,
      exact: true,
    },
    {
      path: `${RoutePaths.UNSUBSCRIBE}`,
      component: UnSubScribe,
      exact: true,
    },
    {
      path: `${RoutePaths.USECASEDASHBOARD}`,
      component: UseCaseDashboard,
      exact: true,
    },
    {
      path: `${RoutePaths.RESEARCHPAPERS}`,
      component: ResearchPapers,
      exact: true,
    },
    {
      path: `${RoutePaths.NEWS_LETTER}`,
      component: NewsLetter,
      exact: true,
    },
  ];
};

export const nonModulePrivateRoutes = () => {
  return [
    {
      path: `${RoutePaths.COLLECTION}/:collectionName/:id`,
      component: Collection,
      exact: false,
    },
    {
      path: `${RoutePaths.PROFILE}/:tab?`,
      component: MyProfile,
      exact: true,
    },
    {
      path: `${RoutePaths.GET_API}/:id`,
      component: GetApi,
      exact: true,
    },
    {
      path: `${RoutePaths.DATASET}/:id`,
      component: DatasetPage,
      exact: true,
    },
    {
      path: `${RoutePaths.MERGE}`,
      component: Merge,
      exact: true,
    },
    {
      path: `${RoutePaths.PROCESSING_REPORT}/:id`,
      component: DataProcessingReport,
      exact: true,
    },
    {
      path: `${RoutePaths.PUBLICATIONS}`,
      component: Publications,
      exact: true,
    },
  ];
};

export const privateRoutes = () => {
  const routes = [...nonModulePrivateRoutes()];
  routes.push({
    path: RoutePaths.HOME,
    component: Home,
    exact: true,
  });
  return routes;
};
